export default __webpack_public_path__ + "img/BB_RT_NOMA_EF.fcea68f18f752cd231dd7477161b0064.jpg";